<div class="container col-10 col-md-4 p-4 rounded-more text-white bg-without" style="box-shadow:0 0.75em 1.5em rgba(0,0,0,0.75);">
    <form class="" [formGroup]="resetForm" (ngSubmit)="resetPassword()">
        <div class="mb-3">
            <label for="password" class="form-label">Password<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="password" formControlName="password" (input)="clearError()">
        </div>
        <div class="mb-3">
            <label for="passwordConfirmation" class="form-label">Confirm Password<span class="text-danger">*</span></label>
            <input type="password" class="form-control" id="passwordConfirmation" formControlName="passwordConfirmation" (input)="clearError()">
            </div>
        <div class="mb-3 text-center"  >
            <span class="cursor-pointer" [routerLink]="['/']" routerLinkActive="router-link-active">Go to home</span>
        </div>
        <div class="text-center text-success small mb-3" *ngIf="successMailSent">{{mailSentMessage}}</div>
        <div class="text-center text-danger small mb-3" *ngIf="passwordError">{{resetError}}</div>
        <div class="d-flex justify-content-center">
            <button type="submit" class="btn btn-outline-light" [disabled]="resetForm.invalid">Reset</button>
        </div>
    </form>
</div>
